export const getLoading = (state) => state.registration_activation.loading;
export const getMessage = (state) => state.registration_activation.message;
export const getError = (state) => state.registration_activation.error;

export const isActivated = (state) => state.registration_activation.activated;
export const getToken = (state) => state.registration_activation.token;

